import { IMetaDataServiceImpl } from '../services/metadata/imetadataserviceimpl';
import { FieldMetaTypeGuards } from './FieldMetaTypeGuards';
import { IEntityMeta, ISalesforceFieldMeta } from './imetadata';

// @TODO: get back here for more entities if any
enum SalesforceOptionsTypeEntityMapping {
  Contact = 'Contact',
  Account = 'Account',
  User = 'User',
  Job = 'TR1__Job__c',
}

export class SalesforceMetaDataServiceImpl implements IMetaDataServiceImpl<ISalesforceFieldMeta> {
  promoteCompositeFields(field: ISalesforceFieldMeta): void {
    if (!this.isCompositeField(field)) {
      return;
    }

    if (field.fields && field.fields.length > 0) {
      throw new Error(`Composite field '${field.path}' already has fields.`);
    }

    const childFields: ISalesforceFieldMeta[] = [];
    field.childrenOfComposite?.forEach((cf) => {
      childFields.push({ ...cf });
    });

    this.setChildren(field, childFields);
  }

  private setChildren(parent: ISalesforceFieldMeta, children: ISalesforceFieldMeta[]): void {
    parent.fields = children;
    this.setParent(children, parent);
  }

  private setParent(fields: ISalesforceFieldMeta[], parent?: ISalesforceFieldMeta): void {
    fields.forEach((field) => {
      field.parent = parent;
      if (parent) {
        field.path = field.parent?.path + '.' + field.path.split('.').pop();
      } // child path to parent
      if (field.fields) {
        const salesforceFields = field.fields.filter(FieldMetaTypeGuards.isSalesforce);
        this.setParent(salesforceFields, field);
      }
    });
  }

  findAssociatedEntity(field: ISalesforceFieldMeta, assocEntityList: { entityType: string; result: Readonly<IEntityMeta> }[]) {
    return this.isPickerField(field)
      ? assocEntityList.find((e) => e.entityType.toLowerCase() === this.getPickerFieldAssociatedEntity(field)?.toLowerCase())
      : assocEntityList.find((e) => e.entityType.toLowerCase() === field.associatedEntity?.toLowerCase());
  }

  updatePickerFieldMeta(field: ISalesforceFieldMeta): void {
    if (this.isAssociatedField(field)) {
      return;
    }
    if (!this.isPickerField(field)) {
      return;
    }
    field.type = field.multiValue ? 'to-many' : 'to-one';
    field.isPickerField = true;
  }

  getAssociatedEntity(field: ISalesforceFieldMeta): string {
    if (this.isPickerField(field)) {
      field.associatedEntity = field.associatedEntity ?? this.getPickerFieldAssociatedEntity(field);
    } else {
      field.associatedEntity = field.associatedEntity ?? field.path;
    }
    return field.associatedEntity;
  }

  private isPickerField(field: ISalesforceFieldMeta): boolean {
    return (field.optionsType as keyof typeof SalesforceOptionsTypeEntityMapping) in SalesforceOptionsTypeEntityMapping;
  }

  private isAssociatedField(field: ISalesforceFieldMeta): boolean {
    return field.type === 'to-many' || field.type === 'to-one';
  }

  private isCompositeField(field: ISalesforceFieldMeta): boolean {
    return field.type === 'composite';
  }

  private getPickerFieldAssociatedEntity(field: ISalesforceFieldMeta): SalesforceOptionsTypeEntityMapping {
    const optionsType = field.optionsType as keyof typeof SalesforceOptionsTypeEntityMapping;
    return SalesforceOptionsTypeEntityMapping[optionsType];
  }
}
